export type GruposNullKpiKey =
  | 'name'
  | 'legalName'
  | 'docType'
  | 'docNumber'
  | 'companiesCount'
  | 'unitsCount'
  | 'volumeMwm'
  | 'exposure'
  | 'exposurePercentage'
  | 'profile'
  | 'status'
  | 'crmId'
  | 'accountManager'
  | 'clientSince';

export interface GruposNullKpiItem {
  key: GruposNullKpiKey;
  label: string;
  hint?: string;
  required?: boolean;
  /** Texto sob a contagem quando "vazio" não descreve o card. */
  emptyLabel?: string;
}

export const GRUPOS_NULL_KPI_ITEMS: GruposNullKpiItem[] = [
  { key: 'name', label: 'Nome', required: true },
  { key: 'legalName', label: 'Razão social', required: true },
  { key: 'docType', label: 'Tipo doc', required: true },
  { key: 'docNumber', label: 'CNPJ/CPF', required: true },
  {
    key: 'companiesCount',
    label: 'Qtd. de empresas',
    hint: 'Grupo sem empresa cadastrada',
    emptyLabel: 'sem empresas',
  },
  {
    key: 'unitsCount',
    label: 'Qtd. de unidades',
    hint: 'Grupo sem unidades',
    emptyLabel: 'sem unidades',
  },
  { key: 'volumeMwm', label: 'Volume (MWm)', required: true },
  { key: 'exposure', label: 'Exposição', required: true },
  { key: 'exposurePercentage', label: '% Exposição', required: true },
  { key: 'profile', label: 'Perfil', required: true },
  { key: 'status', label: 'Status', required: true },
  { key: 'clientSince', label: 'Cliente desde', required: true },
];

export const EMPTY_NULL_KPIS: Record<GruposNullKpiKey, number> = {
  name: 0,
  legalName: 0,
  docType: 0,
  docNumber: 0,
  companiesCount: 0,
  unitsCount: 0,
  volumeMwm: 0,
  exposure: 0,
  exposurePercentage: 0,
  profile: 0,
  status: 0,
  crmId: 0,
  accountManager: 0,
  clientSince: 0,
};
